var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 383"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 0H.5v383h383V249.3h-63.6C298 298.1 248.7 332 192.3 332c-77.8 0-140.8-63.6-140.8-140.8C51.4 114 114.5 51 192.3 51c57.5 0 106.8 35 128.7 84.9h62.5V0z",
    fill: "#fff572"
  })));
}
export var url = __webpack_public_path__ + "8ab9d3cdad1067f5c77f694255757f31.svg";
;
export default SvgCelo;